import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createPublicClient, http } from 'viem';
import { chainId, rpc } from '@/store';
import { chains } from '@/utils/wagmi';

const ProviderContext = createContext(null);


export const ProviderProvider = ({ children }) => {
  const _rpc = useSelector(rpc);
  const _chainId = useSelector(chainId);
  const [provider, setProvider] = useState(null);

  useEffect(() => {
    if (!_rpc) return
    const initProvider = async () => {
      try {
        const currentChain = chains.find(c => c.id === _chainId);

        const publicClient = createPublicClient(
          {
            batch: {
              multicall: true,
            },
            chain: currentChain,
            transport: http(_rpc)
          }
        )
        setProvider(publicClient);
      } catch (error) {
        console.log("初始化节点失败", error.toString());
      }
    };

    initProvider();
  }, [_rpc]);

  return (
    <ProviderContext.Provider value={{ provider }}>
      {children}
    </ProviderContext.Provider>
  );
};

// 直接获取 provider 的 Hook
export const useProviderInstance = () => {
  const { provider } = useContext(ProviderContext);
  return provider;
};